import { FETCH_USERS_COUNT, FETCH_USERS_COUNT_SUCCESS, FETCH_USERS_COUNT_FAILURE } from '../actions';

const initialState = {
  users_count: {},
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_USERS_COUNT:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_USERS_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        users_count: action.data
      };
    case FETCH_USERS_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        users_count: {}
      };
    default:
      return state;
  }
}